import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";

function NotificationsContainer(props) {
    return <ToastContainer
        hideProgressBar
        position="bottom-right"
        theme="dark"
        {...props}
    />
}

export default NotificationsContainer;
